import { Box, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import CommonTable from 'components/commonTable/CommonTable';
import PropTypes from 'prop-types';
import React from 'react';
import { formatDate } from 'utils/CommonFunction';
import { revenueOption } from 'utils/StaticData';
import { sideBarRoutes } from 'utils/StaticData';

const RoleBasedMerchantList = ({ tableData, isLoading, role }) => {
  const textColor = useColorModeValue('primary', 'white');
  const columnHelper = createColumnHelper();
  const columns = [
    // columnHelper.accessor((row) => row?.merchantId, {
    //   id: 'merchantId',
    //   header: () => (
    //     <Text
    //       align="left"
    //       fontSize={{ sm: '10px', lg: '12px' }}
    //       color="gray.400"
    //       whiteSpace="nowrap"
    //     >
    //       Merchant Id
    //     </Text>
    //   ),
    //   cell: (info) => (
    //     <Text color={textColor} fontSize="sm" fontWeight="600" align="left">
    //       {info.getValue()}
    //     </Text>
    //   ),
    // }),
    columnHelper.accessor((row) => row?.merchantName, {
      id: 'merchantName',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
          width="50px"
          whiteSpace="nowrap"
        >
          Merchant
        </Text>
      ),
      cell: (info) => (
        <Flex align="center">
          <Text color={textColor} fontSize="sm" fontWeight="600">
            {info.getValue() ? info.getValue() : 'N/A'}
          </Text>
        </Flex>
      ),
    }),
  ];

  if (role === sideBarRoutes?.Seller) {
    columns.push(
      columnHelper.accessor((row) => row?.commissionOn, {
        id: 'commissionOn',
        header: () => (
          <Text
            justifyContent="space-between"
            align="center"
            fontSize={{ sm: '10px', lg: '12px' }}
            color="gray.400"
            width="50px"
            whiteSpace="nowrap"
          >
            Commission On
          </Text>
        ),
        cell: (info) => (
          <Flex align="center">
            <Text color={textColor} fontSize="sm" fontWeight="600">
              {revenueOption?.find((revenue) => revenue.id === info.getValue())
                ?.label || 'N/A'}
            </Text>
          </Flex>
        ),
      }),
      columnHelper.accessor((row) => row?.commission, {
        id: 'commission',
        header: () => (
          <Text
            justifyContent="space-between"
            align="center"
            fontSize={{ sm: '10px', lg: '12px' }}
            color="gray.400"
            width="80px"
            whiteSpace="nowrap"
          >
            Commission
          </Text>
        ),
        cell: (info) => (
          <Flex align="center">
            <Text color={textColor} fontSize="sm" fontWeight="600">
              {info.getValue() ? `${info.getValue()}%` : 'N/A'}
            </Text>
          </Flex>
        ),
      }),
      columnHelper.accessor((row) => row?.sellerAllocatedDate, {
        id: 'sellerAllocatedDate	',
        header: () => (
          <Text
            justifyContent="space-between"
            align="center"
            fontSize={{ sm: '10px', lg: '12px' }}
            color="gray.400"
            width="80px"
            whiteSpace="nowrap"
          >
            Allocated
          </Text>
        ),
        cell: (info) => (
          <Flex align="center">
            <Text color={textColor} fontSize="sm" fontWeight="600">
              {/* {info.getValue()} */}
              {formatDate(info.getValue())}
            </Text>
          </Flex>
        ),
      }),
      columnHelper.accessor('definition', {
        id: 'definition',
        header: () => (
          <Text
            justifyContent="space-between"
            align="center"
            fontSize={{ sm: '10px', lg: '12px' }}
            color="gray.400"
          >
            DEFINITION
          </Text>
        ),
        cell: (info) => {
          const definition = info.getValue();

          // Handle object format
          if (definition && typeof definition === 'object') {
            return (
              <Box>
                <Text
                  color="secondaryGray.900"
                  fontSize="sm"
                  fontWeight="600"
                  mb={1}
                >
                  Customer Purchases:{' '}
                  {definition.includeCustomerPurchases ? 'Yes' : 'No'}
                </Text>
                <Text
                  color="secondaryGray.900"
                  fontSize="sm"
                  fontWeight="600"
                  mb={1}
                >
                  Transaction Cost:{' '}
                  {definition.includeTransactionCost ? 'Yes' : 'No'}
                </Text>
                <Text color="secondaryGray.900" fontSize="sm" fontWeight="600">
                  Powerbank Cost:{' '}
                  {definition.includePowerbankCost ? 'Yes' : 'No'}
                </Text>
              </Box>
            );
          }

          // Fallback for null/undefined values
          return (
            <Text color="gray.400" fontSize="sm" fontStyle="italic">
              No definition available
            </Text>
          );
        },
      }),
    );
  } else {
    columns.push(
      columnHelper.accessor((row) => row?.locationId, {
        id: 'locationId',
        header: () => (
          <Text
            justifyContent="space-between"
            align="center"
            fontSize={{ sm: '10px', lg: '12px' }}
            color="gray.400"
            width="50px"
            whiteSpace="nowrap"
          >
            Location Id
          </Text>
        ),
        cell: (info) => (
          <Flex align="center">
            <Text color={textColor} fontSize="sm" fontWeight="600">
              {info.getValue()}
            </Text>
          </Flex>
        ),
      }),
      columnHelper.accessor((row) => row?.address, {
        id: 'address',
        header: () => (
          <Text
            justifyContent="space-between"
            align="center"
            fontSize={{ sm: '10px', lg: '12px' }}
            color="gray.400"
            width="80px"
            whiteSpace="nowrap"
          >
            Address
          </Text>
        ),
        cell: (info) => (
          <Flex align="center">
            <Text color={textColor} fontSize="sm" fontWeight="600">
              {info.getValue()}
            </Text>
          </Flex>
        ),
      }),
    );
  }

  return (
    <>
      <Box pt="4px">
        <CommonTable
          columns={columns}
          data={tableData}
          isLoading={isLoading}
          keyValue="id"
          dynamicWidth={{
            merchantName: '200px',
            locationId: '200px',
            address: '200px',
            commission: '200px',
            commissionOn: '200px',
            sellerAllocatedDate: '200px',
            definition: '250px',
          }}
        />
      </Box>
    </>
  );
};

RoleBasedMerchantList.propTypes = {
  tableData: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  role: PropTypes.number,
};

export default RoleBasedMerchantList;
